
async function point_expired_check(p_customer_id, p_term_date) {
    if (!p_customer_id) {
        return false;
    }
    
    let obj = { user_id: p_customer_id, term_date: Number(p_term_date) };
    let method = "POST";
    let body = JSON.stringify(obj);
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    let url = "https://o8yngpgb2b.execute-api.ap-northeast-1.amazonaws.com/EcPointExpireCheck";

    let ret = false;
    await fetch(url, { method, headers, body })
        .then((response) => {
            return response.json();
        })
        .then((result) => {

            if (result.length == 0) {
                ret = false;
                return;
            }
            result.forEach(ele => {
                if (ele['current_point'] > 0){
                    // 現在ポイントが１以上の場合のみ
                    ret = true
                }
            });

        })
        .catch((e) => {
            console.log("error");
            ret = false;
        })

    return ret;

}

function setCurrentEcPoint(targetElemetId) {
    let pointBalance = 0;
    if (greaterScriptVersion("0-3-2")) {
        var easyPointsSession = getEasyPointsSession();
        pointBalance = easyPointsSession.pointBalance;
    } else {
        pointBalance = localStorage.getItem("pointBalance");
    }
    if (!pointBalance){
        pointBalance = "-"
    }
    document.getElementById(targetElemetId).innerHTML = pointBalance;

}

async function checkLinkedMcAccount(p_customer_id, is_linked_check = false){
    if (!p_customer_id) {
        return true;
    }

    let obj = { customer_id: p_customer_id };
    let method = "POST";
    let body = JSON.stringify(obj);
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    let url = "https://o8yngpgb2b.execute-api.ap-northeast-1.amazonaws.com/LinkageAccountCheck";

    let ret = true;
    await fetch(url, { method, headers, body })
        .then((response) => {
            return response.json();
        })
        .then((result) => {
            if (result.is_linked && !result.is_active){
                ret = false;
            }
            if (is_linked_check && !result.is_linked && !result.is_active){
                // リンクチェック、および未紐づけの場合
                ret = false;
            }
        })
        .catch((e) => {
            console.log("error");
        })
    
    return ret;
}